import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { loading } from '../../../actions/sessions';

export default function NetXIntro() {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loading(false));
  }, []);

  return (
    <div role="main" id="content" className="has-text-centered mb-6">
      <div className="box px-4 pt-6 pb-5 my-6">
        <p className="has-text-weight-bold is-size-4 has-text-centered ">
          Welcome to Credit Key
        </p>
        <p className="my-1 is-size-6 has-text-centered ">
          Please choose your business type to continue:
        </p>
        <div className="my-4">
          <div
            className="is-flex is-align-items-center is-justify-content-space-between p-4 login-button"
            onClick={() => history.push('/init/new_user')}
          >
            <div className="is-flex is-align-items-center">
              <div className="fa-3x mr-3">
                <span className="fa-layers fa-fw">
                  <FontAwesomeIcon icon="circle" className="bg-icon" />
                  <FontAwesomeIcon
                    icon={['fal', 'building']}
                    inverse
                    transform="shrink-10"
                    className="primary-icon"
                  />
                </span>
              </div>
              <div className="is-flex is-flex-direction-column is-align-items-start mb-1" style={{ letterSpacing: '0.005em' }}>
                <h2 className="has-text-weight-semibold has-text-left">Enterprise, Government, Non-profit</h2>
                <p className='is-size-7'>Select if ANY of the following apply:</p>
                <ul className='is-size-7 has-text-left' style={{ listStyle: 'disc' }}>
                  <li className='ml-2'>Over $5 Million+ annual revenue</li>
                  <li className='ml-2'>Publicly traded company</li>
                  <li className='ml-2'>Government / Municipality</li>
                  <li className='ml-2'>School or educational institution</li>
                </ul>
              </div>
            </div>
            <FontAwesomeIcon
              icon={['fal', 'chevron-right']}
              className="mr-2"
            />
          </div>
          <div
            className="is-flex is-align-items-center is-justify-content-space-between p-4 my-3 login-button"
            onClick={() => window.location.href = process.env.REACT_APP_APPLY_URL}
          >
            <div className="is-flex is-align-items-center">
              <div className="fa-3x mr-3">
                <span className="fa-layers fa-fw">
                  <FontAwesomeIcon icon="circle" className="bg-icon" />
                  <FontAwesomeIcon
                    icon={['fal', 'shop']}
                    inverse
                    transform="shrink-10"
                    className="primary-icon"
                  />
                </span>
              </div>
              <div className="is-flex is-flex-direction-column is-align-items-start mb-1" style={{ letterSpacing: '0.005em' }}>
                <h2 className="has-text-weight-semibold has-text-left">Small to Medium Business</h2>
                <ul className='is-size-7 has-text-left' style={{ listStyle: 'disc' }}>
                  <li className='ml-2'>In business over 1 year</li>
                  <li className='ml-2'>$40,000+ annual revenue</li>
                  <li className='ml-2'>Personal FICO score over 600</li>
                </ul>
              </div>
            </div>
            <FontAwesomeIcon
              icon={['fal', 'chevron-right']}
              className="mr-2"
            />
          </div>
        </div>
        <p className="has-text-weight-semibold is-size-7 mt-6">
          Already have a Credit Key account?{' '}
          <span
            className="is-clickable"
            style={{ color: '#0A60E0' }}
            onClick={() => history.push('/init/existing_user')}
          >
            Sign In
          </span>
        </p>
      </div>
    </div>
  );
}